module.exports = __webpack_public_path__ + "static/media/message-group-2x.21ea08ad.png";